export default __webpack_public_path__ + "static/media/folder.f2ce6deb.svg";